import React from 'react';
import JobCard from './JobCard';

function JobList({ jobs, loading, error, showActions = true, disableLink = false, applicationView = false, savedView = false, onUnsave, onCancel }) {
  if (loading) {
    return <div className="rounded-3xl bg-white p-8 text-center text-slate-600 shadow-sm">Loading jobs...</div>;
  }

  if (error) {
    return <div className="rounded-3xl bg-rose-50 p-8 text-center text-rose-700 shadow-sm">Error: {error}</div>;
  }

  if (!jobs || jobs.length === 0) {
    return <div className="rounded-3xl bg-white p-8 text-center text-slate-500 shadow-sm">No jobs found.</div>;
  }

  return (
    <div className="space-y-4">
      {jobs.map((job) => (
        <JobCard key={job.id} job={job} showActions={showActions} disableLink={disableLink} applicationView={applicationView} savedView={savedView} onUnsave={onUnsave} onCancel={onCancel} />
      ))}
    </div>
  );
}

export default JobList;